export enum TypeContratEnum {
    OFFRE = "Appel d'offre",
    PROJET = "Appel à projet",
    RESSIF = "Ressif",
    RESSIF_SSIE = "SSIE Ressif",
    RESSIF_HORS_SSIE = "SSIE Hors Ressif",
  }